export enum ContactsPageTableMode {
  Client = 'Contacts',
  Entity = 'Companies'
}
